/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseModuleUpgradeAcceptResponseData } from './genericApiResponseModuleUpgradeAcceptResponseData';
import type { GenericApiResponseModuleUpgradeAcceptResponseMessage } from './genericApiResponseModuleUpgradeAcceptResponseMessage';
import type { GenericApiResponseModuleUpgradeAcceptResponsePagination } from './genericApiResponseModuleUpgradeAcceptResponsePagination';
import type { GenericApiResponseModuleUpgradeAcceptResponseError } from './genericApiResponseModuleUpgradeAcceptResponseError';

export interface GenericApiResponseModuleUpgradeAcceptResponse {
  data?: GenericApiResponseModuleUpgradeAcceptResponseData;
  message?: GenericApiResponseModuleUpgradeAcceptResponseMessage;
  pagination?: GenericApiResponseModuleUpgradeAcceptResponsePagination;
  error?: GenericApiResponseModuleUpgradeAcceptResponseError;
  statusCode?: number;
}
